import { KeyCloakService } from '@inform-appshell/fusion-kit-keycloak';

import { loadConfiguration } from './services/config';
import { setupApp } from './setup';

async function main() {
  const config = await loadConfiguration();

  const authService = new KeyCloakService({
    url: config.keycloak.url,
    realm: config.keycloak.realm,
    clientId: config.keycloak.clientId,
    redirectUri: config.keycloak.redirectUrl,
  });

  const authenticated = await authService.init();
  if (!authenticated) {
    await authService.login();
    return;
  }

  const routerBase = import.meta.env.BASE_URL.startsWith('/') ? import.meta.env.BASE_URL : '/';
  const app = setupApp({ basePath: routerBase, authService, apiBaseUrl: config.apiUrl });
  app.mount('#app');
}

main().catch((error) => {
  console.error('Failed to start app:', error);
});
